import { render, staticRenderFns } from "./group-notifications.vue?vue&type=template&id=3e6e5dab&scoped=true&"
import script from "./group-notifications.vue?vue&type=script&lang=js&"
export * from "./group-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6e5dab",
  null
  
)

export default component.exports